<template>
  <div class="userManage">
    <el-dialog
      class="export"
      title="导出数据"
      :visible.sync="showExport"
      width="600px"
    >
      <div class="export-tips">请选择需要导出的字段，点击确认即可导出表格</div>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <el-checkbox-group v-model="exportSelect" @change="handleCheckedChange">
        <el-checkbox
          v-for="option in exportOptions"
          :label="option"
          :key="option"
          class="export-select"
          >{{ option }}</el-checkbox
        >
      </el-checkbox-group>
      <div class="export-btns">
        <el-button @click="showExport = false">取消</el-button>
        <el-button type="primary" @click="exportStudent">导出</el-button>
      </div>
    </el-dialog>
    <div>
      <div class="line" style="padding-top: 0">
        <el-input
          class="search-input"
          v-model="uid"
          placeholder="输入用户ID"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="nick_name"
          placeholder="输入用户昵称"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="classes_no"
          placeholder="输入班级编号"
          clearable
        ></el-input>
        <el-select
          class="search-select"
          v-model="school_id"
          placeholder="用户学校"
          clearable
        >
          <el-option
            v-for="item in schoolList"
            :label="item.nick_name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
        <el-select
          class="search-select"
          v-model="grade"
          placeholder="用户年级"
          clearable
        >
          <el-option
            v-for="item in grades"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
        <el-select
          class="search-select"
          v-model="is_vip"
          placeholder="会员状态"
          clearable
        >
          <el-option label="会员" value="1"></el-option>
          <el-option label="非会员" value="0"></el-option>
        </el-select>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
        <el-button
          v-if="user.role == 'school'"
          class="search-button"
          type="primary"
          @click="toExport()"
          >导出数据</el-button
        >
      </div>
      <el-table class="data-table" :data="studentData" v-loading="loading">
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column label="用户信息" width="width" min-width="200">
          <template slot-scope="scope">
            <div class="flex">
              <img
                class="avatar"
                :src="scope.row.avatar || require('../../images/student.png')"
                alt=""
              />
              <div style="width: 100%">
                <div class="userInfo">{{ scope.row.nick_name }}</div>
                <div class="userInfo">手机：{{ scope.row.phone }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="学校信息" width="200">
          <template slot-scope="scope">
            <div style="width: 100%">
              <div class="userInfo">{{ scope.row.school }}</div>
              <div class="userInfo">{{ scope.row.grade_name }}</div>
              <div class="userInfo">{{ scope.row.classes }}</div>
              <div class="userInfo">班级编号：{{ scope.row.classes_no }}</div>
              <div class="userInfo">学号：{{ scope.row.user_name }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="会员状态" width="80">
          <template slot-scope="scope">
            <div>{{ scope.row.is_vip == 0 ? '非会员' : '会员' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="collect_count"
          label="收藏课程数"
          width="width"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="study_count"
          label="在学课程数"
          width="width"
        ></el-table-column>
        <el-table-column align="center" label="学习总时长" width="width">
          <template slot-scope="scope">{{
            getFormatLearnTime(scope.row.total_duration)
          }}</template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="toLog(scope.row)"
                >学习日志</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="toProgress(scope.row)"
                >学习进度</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onPageChange"
        :current-page="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 学习日志 -->
    <el-dialog title="学习日志" :visible.sync="logVisible" width="60%">
      <div>
        <div class="line" style="padding-top: 0">
          <el-date-picker
            class="search-input"
            style="width: 180px"
            v-model="searchLogTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          >
          </el-date-picker>
          <el-button
            class="search-button"
            type="primary"
            @click="searchLog(true)"
            >查询</el-button
          >
        </div>
        <el-table class="data-table" :data="logData" v-loading="logLoading">
          <el-table-column
            align="center"
            prop="date"
            label="日期"
            width="width"
          ></el-table-column>
          <el-table-column
            align="center"
            label="学习时长/所学课程"
            width="width"
          >
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.item" :key="index">
                {{ item.day }} {{ item.course_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="totalTime"
            label="当天学习总时长"
            width="width"
          >
            <template slot-scope="scope">
              {{ getFormatLearnTime(scope.row.total_duration) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="onLogPageChange"
          :current-page="pageLog"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="totalLog"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 学习进度 -->
    <el-dialog title="学习进度" :visible.sync="courseVisible" width="80%">
      <div>
        <div class="line" style="padding-top: 0">
          <el-input
            class="search-input"
            v-model="courseNameSearch"
            placeholder="输入课程标题"
            clearable
          ></el-input>
          <el-button
            class="search-button"
            type="primary"
            @click="searchCourse()"
            >查询</el-button
          >
        </div>
        <el-table
          class="data-table"
          :data="courseData"
          v-loading="courseLoading"
        >
          <el-table-column
            align="center"
            prop="course_name"
            label="课程名称"
            width="width"
          ></el-table-column>
          <el-table-column align="center" label="是否完课" width="width">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.finish == scope.row.total && scope.row.total != 0
                    ? '是'
                    : '否'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="完播课件数量/总课件数量"
            width="width"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.finish }}/{{ scope.row.total }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="课程学习总时长" width="width">
            <template slot-scope="scope">
              <div>
                {{ getFormatLearnTime(scope.row.duration) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="toDetail(scope.row)"
                  >学习详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="onProgressPageChange"
          :current-page="pageProgress"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="totalProgress"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="courseVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 学习详情 -->
    <el-dialog title="学习详情" :visible.sync="detailVisible" width="80%">
      <div>
        <div class="line" style="padding-top: 0">
          <el-input
            class="search-input"
            v-model="detailNameSearch"
            placeholder="输入课件标题"
            clearable
          ></el-input>
          <el-button
            class="search-button"
            type="primary"
            @click="searchDetail(true)"
            >查询</el-button
          >
        </div>
        <el-table
          class="data-table"
          :data="detailData"
          v-loading="courseLoading"
        >
          <el-table-column align="center" label="课时序号" width="width">
            <template slot-scope="scope">
              <div>
                {{ scope.$index + 1 + (pageDetail - 1) * 10 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="title"
            label="课件名称"
            width="width"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pay_count"
            label="播放次数"
            width="width"
          ></el-table-column>
          <el-table-column align="center" label="课程学习总时长" width="width">
            <template slot-scope="scope">{{
              getFormatLearnTime(scope.row.duration)
            }}</template>
          </el-table-column>
          <el-table-column align="center" label="是否完播" width="width">
            <template slot-scope="scope">
              <div>
                {{ scope.row.complete ? '是' : '否' }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="onDetailPageChange"
          :current-page="pageDetail"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="totalDetail"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            courseVisible = true
            detailVisible = false
          "
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import {
  getStudentList,
  getSchoolList,
  getStudyProgress,
  getStudyDetail,
  getStudyLog,
  student_export,
} from '@/api/api.js'
import { getFormatLearnTime } from '@/utils/common'
import { getGradesList } from '@/utils/common'
import { ip } from '../../const'
export default {
  name: 'UserManage',
  data: () => ({
    user: {},
    role: 2, // 1-超管 2-管理 3-老师
    uid: '',
    nick_name: '',
    classes_no: '',
    school_id: '',
    schoolList: [],
    grade: '',
    grades: [],
    is_vip: '',
    loading: false,
    studentData: [],
    total: 3,
    page: 1,
    logVisible: false,
    logLoading: false,
    logData: [],
    pageLog: 1,
    totalLog: 3,
    searchLogTime: '',
    courseNameSearch: '', //课程进度搜索条件
    progressUid: null,
    progressId: null,
    detailCourseId: null,
    courseVisible: false,
    courseLoading: false,
    courseData: [],
    pageProgress: 1,
    totalProgress: 3,
    detailVisible: false,
    detailLoading: false,
    detailNameSearch: '',
    detailData: [],
    pageDetail: 1,
    totalDetail: 0,

    showExport: false,
    exportOptions: [
      // '班级编号',
      // '学号',
      // '学生姓名',
      // '学校',
      // '年级',
      // '班级',
      // '在学课程数',
      // '完课数量',
      // '学习总时长',
      // '收藏课程',
      // '提问次数',

      '学校',
      '年级',
      '班级',
      '班级编号',
      '学号',
      '学生姓名',
      '在学课程数',
      '完课数量',
      '学习总时长',
      '收藏课程',
      '提问次数',
    ],
    exportSelect: [],
    checkAll: false,
    isIndeterminate: true,
  }),
  async mounted() {
    let user = JSON.parse(localStorage.getItem('mykc-user'))
    this.user = user

    if (this.$route.query.id) {
      this.uid = this.$route.query.id
    }
    this.search()
    // 获取学校列表
    getSchoolList().then((res) => {
      this.schoolList = res.data.data
    })
    // 获取年级列表
    this.grades = await getGradesList()
  },
  methods: {
    getFormatLearnTime,
    sortExport(list) {
      let sort = []
      for (let i = 0; i < list.length; i++) {
        sort.push(this.exportOptions.indexOf(list[i]))
      }
      console.log('sort', sort)
      sort.sort((a, b) => {
        return a - b
      })
      console.log('sort', sort)
      let sortList = []
      for (let i = 0; i < sort.length; i++) {
        sortList.push(this.exportOptions[sort[i]])
      }
      console.log('sortList', sortList)
      return sortList
    },
    exportStudent() {
      if (this.exportSelect.length == 0) {
        this.$message({
          message: '请先选择导出字段！',
          type: 'warning',
        })
        return
      }
      // console.log('exportSelect', this.exportSelect)
      // return
      let params = {}
      if (this.nick_name) {
        params.nick_name = this.nick_name
      }
      if (this.classes_no) {
        params.classes_no = this.classes_no
      }
      if (this.school_id) {
        params.school_id = this.school_id
      }
      if (this.grade) {
        params.grade = this.grade
      }
      if (this.is_vip) {
        params.is_vip = this.is_vip
      }
      if (this.uid) {
        params.id = this.uid
      }
      params.header = this.sortExport(this.exportSelect)
      // student_export(params)
      // return
      let data = {
        url: `${ip}/admin/user/student_export`,
        method: 'post',
        data: params,
        fileName: '学生信息.xlsx',
      }
      console.log('data', data)
      this.exportExcelMethod(data)
    },
    exportExcelMethod(data) {
      let token = localStorage.getItem('mykc-token')
      axios({
        method: data.method,
        url: `${data.url}${data.params ? '?' + data.params : ''}`,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 8000,
        data: data.data,
      })
        .then((res) => {
          const link = document.createElement('a')
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel',
          })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          // link.download = res.headers['content-disposition'] //下载后文件名
          link.download = data.fileName //下载的文件名
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          // this.$message({
          //   message: '下载完成',
          //   type: 'success',
          // })
          this.showExport = false
        })
        .catch((error) => {})
    },
    toExport() {
      this.exportSelect = []
      this.checkAll = false
      this.isIndeterminate = true
      this.showExport = true
    },
    handleCheckAllChange(val) {
      this.exportSelect = val ? this.exportOptions : []
      this.isIndeterminate = false
    },
    handleCheckedChange() {},
    search(changeBottomPage) {
      if(!changeBottomPage){
        this.page = 1
      }
      let params = {
        page: this.page,
      }
      if (this.nick_name) {
        params.nick_name = this.nick_name
      }
      if (this.classes_no) {
        params.classes_no = this.classes_no
      }
      if (this.school_id) {
        params.school_id = this.school_id
      }
      if (this.grade) {
        params.grade = this.grade
      }
      if (this.is_vip) {
        params.is_vip = this.is_vip
      }
      if (this.uid) {
        params.id = this.uid
      }
      getStudentList(params).then((res) => {
        console.log(res.data)
        this.studentData = res.data.data.list
        this.total = res.data.data.total
      })
    },
    toLog(row) {
      this.logVisible = true
      this.progressUid = row.id
      this.searchLog(true)
    },
    toProgress(row) {
      this.courseVisible = true
      this.progressUid = row.id
      this.searchCourse(true)
    },
    toDetail(row) {
      this.courseVisible = false
      this.detailVisible = true
      this.progressId = row.id
      this.detailCourseId = row.course_id
      this.searchDetail(true)
    },
    searchLog(reset = false) {
      if (reset) {
        this.pageLog = 1
      }
      let params = {
        page: this.pageLog,
        student_id: this.progressUid,
      }
      if (this.searchLogTime) {
        params.date = this.searchLogTime
      }
      getStudyLog(params).then((res) => {
        console.log('123123', res)
        this.logData = res.data.data.list
        this.totalLog = res.data.data.list.length
      })
    },
    onPageChange(e) {
      this.page = e
      this.search(true)
    },
    onLogPageChange(e) {
      this.pageLog = e
      this.searchLog()
    },
    onProgressPageChange(e) {
      this.pageProgress = e
      this.searchCourse()
    },
    onDetailPageChange(e) {
      this.pageDetail = e
      this.searchDetail()
    },
    searchCourse(reset = false) {
      if (reset) {
        this.pageProgress = 1
      }
      let params = {
        page: this.pageProgress,
        user_id: this.progressUid,
      }
      if (this.courseNameSearch) {
        params.course_name = this.courseNameSearch
      }
      getStudyProgress(params).then((res) => {
        this.courseData = res.data.data.list
        this.totalProgress = res.data.data.total
      })
    },
    searchDetail(reset = false) {
      if (reset) {
        this.pageDetail = 1
      }
      let params = {
        page: this.pageDetail,
        course_id: this.detailCourseId,
        user_id: this.progressUid,
      }
      if (this.detailNameSearch) {
        params.title = this.detailNameSearch
      }
      getStudyDetail(params).then((res) => {
        if (res.data.code == 0) {
          this.detailData = res.data.data.list
          this.totalDetail = res.data.data.total
        }
      })
    },
  },
}
</script>

<style lang="less">
.userManage {
  .flex {
    display: flex;
    align-items: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
  .export {
    .export-tips {
      text-align: center;
      margin-bottom: 20px;
    }
    .export-select {
      margin-top: 10px;
    }
    .export-btns {
      margin-top: 30px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
